import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import MainLayout from '../layout/MainLayout'
import Constants from '../utils/constants'
import { showToast } from '../utils/toast'

const ProtectedRoute = () => {
  const navigate = useNavigate()
  const { isAuthenticated, user, loading } = useSelector((state) => state.auth)

  useEffect(() => {
    if (loading) return

    if (!isAuthenticated) {
      navigate('/admin/login')
      return
    }

    if (user?.role !== Constants.ROLES.ADMIN) {
      showToast('You are not authorised to access this resource', 'error')
      navigate('/admin/login')
    }
  }, [isAuthenticated, user, loading, navigate])

  if (loading || !isAuthenticated) {
    return null
  }

  return <MainLayout />
}

export default ProtectedRoute
